import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { NavbarViewProps } from './navbar.props';

const NavbarView: React.FC<NavbarViewProps> = ({
  isMenuOpen, setIsMenuOpen, user, isAuthenticated, handleLogout, navigate,
}) => {
  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                <path d="M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z" />
              </svg>
            </div>
            <span className="text-xl font-bold text-gray-900">drimcms</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">Настани</Link>
            <Link to="/organizers" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">Организатори</Link>
            <Link to="/posts" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">Постови</Link>
            {isAuthenticated && user?.role === 'Admin' && (
              <Link to="/cms" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">CMS</Link>
            )}
          </div>

          <div className="hidden md:flex items-center space-x-4">
            {isAuthenticated ? (
              <>
                <span className="text-sm text-gray-600">Добредојдовте, {user?.name}</span>
                <Button variant="ghost" size="sm" onClick={handleLogout}>
                  <LogOut className="w-4 h-4 mr-2" />
                  Одјави се
                </Button>
              </>
            ) : (
              <>
                <Button variant="ghost" size="sm" onClick={() => navigate('/login')}>Најави се</Button>
                <Button size="sm" onClick={() => navigate('/register')}>Регистрирај се</Button>
              </>
            )}
            <div className="w-8 h-6 rounded overflow-hidden cursor-pointer">
              <span className="text-2xl">🇲🇰</span>
            </div>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-white">
          <div className="px-4 py-3 space-y-3">
            <Link to="/" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md" onClick={() => setIsMenuOpen(false)}>Настани</Link>
            <Link to="/organizers" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md" onClick={() => setIsMenuOpen(false)}>Организатори</Link>
            <Link to="/posts" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md" onClick={() => setIsMenuOpen(false)}>Постови</Link>
            {isAuthenticated && user?.role === 'Admin' && (
              <Link to="/cms" className="block px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md" onClick={() => setIsMenuOpen(false)}>CMS</Link>
            )}
            <div className="pt-3 border-t border-gray-200">
              {isAuthenticated ? (
                <>
                  <div className="px-3 py-2 text-sm text-gray-600 mb-2">{user?.name}</div>
                  <Button variant="ghost" className="w-full" onClick={handleLogout}>
                    <LogOut className="w-4 h-4 mr-2" />
                    Одјави се
                  </Button>
                </>
              ) : (
                <>
                  <Button variant="ghost" className="w-full mb-2" onClick={() => { navigate('/login'); setIsMenuOpen(false); }}>Најави се</Button>
                  <Button className="w-full" onClick={() => { navigate('/register'); setIsMenuOpen(false); }}>Регистрирај се</Button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavbarView;
